type Props = {
  s?: boolean
}
export const R = ({ s = true }: Props) => {
  return s ? <sup>&reg;</sup> : <>&reg;</>
}
